import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { KubernetesAccesses } from "./accesses.ts";
import { KubernetesComponents } from "./components.ts";

const KubernetesFilters = {
  cluster: { keys: ["name"] },
  resource: { keys: ["kind", "name", "namespace"] },
  role: { keys: ["name"] },
} as const satisfies AnyFilterSchema;

export type KubernetesFilters = typeof KubernetesFilters;

export const KubernetesRegistration = Registration({
  accesses: KubernetesAccesses,
  category: "resource",
  components: KubernetesComponents,
  docs: { install: "kubernetes", request: "kubernetes/requesting-access" },
  filters: KubernetesFilters,
  itemKind: "cluster",
  label: "Kubernetes",
  logoUrl:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Kubernetes_logo_without_workmark.svg/250px-Kubernetes_logo_without_workmark.svg.png",
  maturity: "ga",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "iam-write" }],
});

registerIntegration("k8s", KubernetesRegistration);
